import React, {useState} from "react";
import {useRecoilState, useRecoilValue} from "recoil";
import {
  designUsingPopmenuState,
  popmenuDeltaUpdatesState,
  popmenuRestaurantsState
} from "../../state/atoms";
import {PopmenuDeltaUpdate} from "../../generated/dashboard-client";
import {approveAll, approveAllForDesignIds, ignore, onReviewApprove, Pos, review} from "../../service/PosService";
import GenericDesignUpdater from "./GenericDesignUpdater";

interface PopmenuDesignUpdaterProps {
  loading: boolean
}

const pos = Pos.Popmenu;

export default function PopmenuDesignUpdater({loading}: PopmenuDesignUpdaterProps) {
  const popmenuRestaurants = useRecoilValue(popmenuRestaurantsState);
  const [reviewDesignId, setReviewDesignId] = useState('');
  const [isReviewModal, setReviewModal] = useState(false);
  const [popmenuReviewUpdates, setPopmenuReviewUpdates] = useState([] as PopmenuDeltaUpdate[]);
  const [loadingDesignIds, setLoadingDesignIds] = useState([] as string[]);
  const [designsUsingPopmenu, setDesignsUsingPopmenu] = useRecoilState(designUsingPopmenuState);
  const [popmenuDeltaUpdates, setPopmenuDeltaUpdates] = useRecoilState(popmenuDeltaUpdatesState);
  const [optionsModalDesignId, setOptionsModalDesignId] = useState('');

  async function popmenuApproveAll(e: React.MouseEvent<HTMLElement>, designId: string) {
    await approveAll(e, designId, setLoadingDesignIds, setOptionsModalDesignId, designsUsingPopmenu, setDesignsUsingPopmenu, pos, popmenuRestaurants, popmenuDeltaUpdates, setPopmenuDeltaUpdates);
  }

  async function popmenuApproveAllForDesignIds(e: React.MouseEvent<HTMLElement>, designIds: string[]) {
    await approveAllForDesignIds(e, designIds, setLoadingDesignIds, setOptionsModalDesignId, designsUsingPopmenu, setDesignsUsingPopmenu, pos, popmenuRestaurants, popmenuDeltaUpdates, setPopmenuDeltaUpdates);
  }

  function popmenuReview(e: React.MouseEvent<HTMLElement>, designId: string) {
    review(e, designId, setReviewModal, setReviewDesignId, popmenuDeltaUpdates, setPopmenuReviewUpdates);
  }

  async function popmenuIgnore(e: React.MouseEvent<HTMLElement>, designId: string) {
    await ignore(e, designId, setLoadingDesignIds, popmenuRestaurants, pos, popmenuDeltaUpdates, setPopmenuDeltaUpdates, setOptionsModalDesignId, designsUsingPopmenu);
  }

  async function onPopmenuReviewApprove(ids: string[]) {
    await onReviewApprove(ids, setReviewModal, setLoadingDesignIds, reviewDesignId, popmenuRestaurants, popmenuDeltaUpdates, designsUsingPopmenu, setDesignsUsingPopmenu, pos, setPopmenuDeltaUpdates, setOptionsModalDesignId);
  }

  return <GenericDesignUpdater posReview={popmenuReview} posApproveAll={popmenuApproveAll} posApproveAllForDesignIds={popmenuApproveAllForDesignIds} posIgnore={popmenuIgnore}
                               deltaUpdates={popmenuDeltaUpdates} designs={designsUsingPopmenu} optionsModalDesignId={optionsModalDesignId}
                               reviewUpdates={popmenuReviewUpdates} loading={loading} loadingDesignIds={loadingDesignIds}
                               onReviewApprove={onPopmenuReviewApprove}
                               setOptionsModalDesignId={setOptionsModalDesignId} isReviewModal={isReviewModal} setReviewModal={setReviewModal}
                               restaurants={popmenuRestaurants} pos={pos}/>
}
